import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
// state
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
// components
import SoFormButton from '../../components/other/SoFormButton';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormStepConfigurationError from './SoFormStepConfigurationError';
import LoadSpinner from 'components/LoadSpinner';
import { ChevronRightIcon } from 'refactored/ui/icons';
import SoFormStepConfigurationInfo from './SoFormStepConfigurationInfo';
import { useTranslation } from 'react-i18next';

const SoFormStepConfigurationFooter = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const isLoading = stepsState.configuration.isLoading;

  return (
    <div className={className}>
      <SoFormStepConfigurationError />
      <SoFormStepConfigurationInfo />
      <SoFormContainer>
        <SoFormButton
          disabled={isLoading}
          onClick={stepsApi.onConfigurationSubmit}
        >
          {!isLoading && (
            <>
              {t('configuration.view_price_options')} <ChevronRightIcon />
            </>
          )}
          {isLoading && <LoadSpinner />}
        </SoFormButton>
      </SoFormContainer>
    </div>
  );
};

SoFormStepConfigurationFooter.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfigurationFooter)`
  width: 100%;
  padding: 0px;
  padding-bottom: 16px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;
